/**
 * Short window after a component starts navigating away from documentation (or
 * corrects the directory itself), during which the URL synchronization hooks
 * must not redirect. Time-based, so overlapping signals extend the window
 * instead of cutting it short.
 */
const NAVIGATION_SETTLE_MS = 100;

let suppressRedirectsUntil = 0;

/** Call right before navigating away from the documentation gallery. */
export function signalNavigationOutsideDocumentation(): void {
  suppressRedirectsUntil = Math.max(suppressRedirectsUntil, Date.now() + NAVIGATION_SETTLE_MS);
}

/** Whether a navigation outside documentation is still settling. */
export function isNavigatingOutside(): boolean {
  return Date.now() < suppressRedirectsUntil;
}
